<template>
  <div>
    <v-card>
      <v-row class="d-flex align-center justify-end mx-2 pa-5" dense>
        <v-col cols="10" class="d-flex align-center">
          <v-text-field
            v-model="itsearch"
            clearable
            label="Search items"
            type="text"
            class="Caption"
            condensed
          />
        </v-col>
        <v-col cols="2">
          <v-icon large color="primary" @click.stop="getProducts"
            >search</v-icon
          >
        </v-col>
      </v-row>

      <v-row dense class="d-flex">
        <v-list-item-subtitle
          class="body-1 text-wrap mx-3 my-1 d-flex justify-center"
        >
          <small>{{ thisproduct.STKMST_DOCNO }}:</small>
          {{ thisproduct.STKMST_DESC }}
        </v-list-item-subtitle>
      </v-row>
      <v-row dense class="d-flex align-center">
        <v-col cols="4">
          <v-list-item-subtitle class="body-1 text-wrap mx-3 my-1">
            <small> LPQ: </small> {{ thisproduct.LP_QTY }}
          </v-list-item-subtitle>
        </v-col>
        <v-col cols="4">
          <v-list-item-subtitle class="body-1 text-wrap mx-3 my-1">
            <small> LPU: </small> {{ thisproduct.LP_UNIT }}
          </v-list-item-subtitle>
        </v-col>
        <v-col cols="4">
          <v-list-item-subtitle class="body-1 text-wrap mx-3 my-1">
            <small> LPR: </small> {{ thisproduct.LP_RATE }}
          </v-list-item-subtitle>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center align-center mx-2 ">
        <v-col cols="3">
          <v-text-field
            ref="Qty"
            v-model="thisprodqty"
            :rules="[() => !!thisprodqty || 'This field is required']"
            label="Qty"
            requiredlder="thisproduct.LP_QTY"
          />
        </v-col>
        <v-col cols="3"> {{ thisproduct.STKMST_UNIT_DOCNO }}(s) </v-col>
        <v-col cols="6">
          <v-text-field
            ref="Rate"
            v-model="thisprodrate"
            :rules="[() => !!thisprodrate || 'This field is required']"
            label="Rate"
            required
          />
        </v-col>
      </v-row>
      <v-row>       
        <v-spacer></v-spacer>
        <div cols="12" class="d-flex justify-end mx-5 headline">
          Line total: {{ this.thisprodamt }}
        </div>
      </v-row>

      <v-card-actions>
        <v-row>
          <v-col cols="4" class="d-flex justify-center">
            <v-btn text color="primary" @click="removeThisItem">
              delete
            </v-btn>
          </v-col>
          <v-col cols="4" class="d-flex justify-center">
            <v-btn text color="primary" @click="cancelDialog">
              cancel
            </v-btn>
          </v-col>
          <v-col cols="4" class="d-flex justify-center">
            <v-btn text color="primary" @click="addThisItem">
              add
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Addeditproduct",
  data() {
    return {
      itsearch: "",
      thisprodqty: 0,
      thisprodrate: 0,    
    };
  },
  computed: {
    thisproduct() {
      return this.$store.getters.thisProduct;
    },
    thiscustomer() {
      return this.$store.getters.thiscustomer;
    },
    thisprodamt() {
      return (this.thisprodqty * this.thisprodrate).toFixed(2);
    },
  },
  methods: {
    getProducts() {
      this.$store.dispatch("getAllProducts", {
        search: this.itsearch,
        doctype: this.thiscustomer.PARTYMST_DOCTYPE,
        docno: this.thiscustomer.PARTYMST_DOCNO,
      });
      this.$emit("showProductDialog");
    },
    removeThisItem() {
      this.$store.dispatch("removeProductFromList", this.thisproduct);
      this.$emit("hideProductDialog");
    },
    cancelDialog() {
      this.$emit("hideProductDialog");
    },
    addThisItem() {
      this.$store.dispatch("addProductToList", {
        STKMST_DOCNO: this.thisproduct.STKMST_DOCNO,
        STKMST_DESC: this.thisproduct.STKMST_DESC,
        STKMST_AVERAGE_COST: this.thisproduct.STKMST_AVERAGE_COST,
        SO_QTY: this.thisprodqty,
        STTRN_UNIT_DOCNO: this.thisproduct.STTRN_UNIT_DOCNO,
        SO_RATE: this.thisprodrate,
        SO_LINE_TOTAL: this.thisprodamt,
        SO_AC_DOCNO: this.thiscustomer.PARTYMST_DOCTYPE,
        SO_SUBLEDGER_DOCNO: this.thiscustomer.PARTYMST_DOCNO,
        STKMST_DETAILS_TXT2: this.thisproduct.STKMST_DETAILS_TXT2
      });
      console.log(this.thisproduct);
      this.$emit("hideProductDialog");
      this.$store.dispatch("selectThisProduct", "");
      this.itsearch = "";
      this.thisprodqty = 0;
      this.thisprodrate = 0;
    },
  },
};
</script>

<style scoped></style>
